import React from 'react';
import PropTypes from 'prop-types';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';

export default function CheckboxQuestionV2({ name, title }) {
  const { handleFormFieldChange, formFieldValue } = useFormContext(name);

  return (
    <div className="flex pl2 mb4">
      <input
        type="checkbox"
        name={name}
        value={formFieldValue ?? false}
        className="b--light-silver"
        onChange={handleFormFieldChange}
      />
      <label htmlFor={name} className="pl2 tertiary f2">
        {title}
      </label>
    </div>
  );
}

CheckboxQuestionV2.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};
